import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from '../services/localstorage.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { ApiService } from '../services/api.service';
import 'rxjs/add/operator/filter';

@Component({
  selector: 'app-space',
  templateUrl: './space.component.html',
  styles: []
})
export class SpaceComponent implements OnInit {

  spaceId: any;
  space: any = {};

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _api: ApiService,
    private _storage: LocalStorageService,
  ) {

    // router.events.subscribe(event => {
    //   console.log('router change');
    // });

    _router.events
      .filter(event => event instanceof NavigationEnd)
      .subscribe((event: NavigationEnd) => {
        this._route.firstChild.params.subscribe(
          params => {
            if (params['id']) {
              this.spaceId = params['id'];
              this._api.spaces
                .retrieve(this.spaceId)
                .subscribe(
                  (data) => {
                    this.space = data;
                  },
                  (errors) => {
                    this._router.navigate(['/', 'home']);
                  }
                );
            }
          });
      });
  }

  ngOnInit() {

  }

  logout(): void {
    this._storage.clear();
    this._router.navigate(['']);
  }

}



// WEBPACK FOOTER //
// ./src/app/space/space.component.ts